import { Bell } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { userApi } from "../../utils/api-axios";

export const NotificationsSettings = () => {
  const { currentUser } = useAuth();
  const [notifications, setNotifications] = useState({
    messages: true,
    marketing: true,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({
    messages: false,
    marketing: false,
  });

  // Load current notification preferences
  useEffect(() => {
    if (currentUser?.emailNotifications) {
      setNotifications(currentUser.emailNotifications);
      setLoading(false);
    } else if (currentUser) {
      // If user exists but no emailNotifications, use defaults
      setLoading(false);
    }
  }, [currentUser]);

  const updateNotificationPreference = async (type, value) => {
    setSaving(prev => ({ ...prev, [type]: true }));

    const updatedNotifications = {
      ...notifications,
      [type]: value,
    };

    try {
      const res = await userApi.updateNotificationPreferences(updatedNotifications);

      if (res.success) {
        setNotifications(updatedNotifications);
      } else {
        alert("An error occurred while updating preferences");
        // Revert switch state on error
        setNotifications(prev => ({ ...prev, [type]: !value }));
      }
    } catch (error) {
      console.error("Error updating notification preference:", error.message);
      alert(error.message || "An error occurred while updating preferences");
      // Revert switch state on error
      setNotifications(prev => ({ ...prev, [type]: !value }));
    } finally {
      setSaving(prev => ({ ...prev, [type]: false }));
    }
  };

  const handleMessagesToggle = (checked) => {
    setNotifications(prev => ({ ...prev, messages: checked }));
    updateNotificationPreference('messages', checked);
  };

  const handleMarketingToggle = (checked) => {
    setNotifications(prev => ({ ...prev, marketing: checked }));
    updateNotificationPreference('marketing', checked);
  };

  return (
    <Card className="border-0 shadow-lg rounded-2xl">
      <CardHeader className="bg-gradient-to-r from-teal-600 to-igbanwo-mint text-white rounded-t-2xl">
        <CardTitle className="flex items-center text-lg">
          <Bell className="w-5 h-5 mr-3" />
          Notifications
        </CardTitle>
      </CardHeader>

      <CardContent className="!p-6 space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <Label className="font-medium">Email Notifications</Label>
            <p className="text-sm text-muted-foreground">
              Receive marketing updates via email
            </p>
          </div>
          <Switch
            checked={notifications.marketing}
            onCheckedChange={handleMarketingToggle}
            disabled={loading || saving.marketing}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <Label className="font-medium">New Messages</Label>
            <p className="text-sm text-muted-foreground">
              Email notifications for new messages
            </p>
          </div>
          <Switch
            checked={notifications.messages}
            onCheckedChange={handleMessagesToggle}
            disabled={loading || saving.messages}
          />
        </div>
      </CardContent>
    </Card>
  );
};